export enum CreateUpdatePartenerEnum {
  create = 'create'
}
